import React from 'react';
import { $ } from '../utils/Utils';
import { Link } from 'react-router-dom';
import * as DATA from '../utils/Data';
import './Menu.css';

export default class Menu extends React.Component {
  constructor() {
    super();
    DATA.BP_PHONE_PHABLET.addListener(this.resetMenu);
  }

  resetMenu(bp) {
    if (bp.matches) {
      $('.nav').style.display = 'none';
      $('.menu-open').style.display = 'block';
      $('.menu-close').style.display = 'none';
    } else {
      $('.nav').style.display = 'block';
      $('.menu-open').style.display = 'none';
      $('.menu-close').style.display = 'none';
    }
  }

  openMenu() {
    if (DATA.BP_PHONE_PHABLET.matches) {
      $('.nav').style.display = 'block';
      $('.menu-open').style.display = 'none';
      $('.menu-close').style.display = 'block';
    }
  }

  closeMenu() {
    if (DATA.BP_PHONE_PHABLET.matches) {
      $('.nav').style.display = 'none';
      $('.menu-open').style.display = 'block';
      $('.menu-close').style.display = 'none';
    }
  }
  render() {
    return (
      <div className="menu">
        <button onClick={this.openMenu} className="menu-open">
          <i className="material-icons">menu</i>
        </button>
        <button onClick={this.closeMenu} className="menu-close">
          <i className="material-icons">close</i>
        </button>
        <nav className="nav">
          <Link onClick={this.closeMenu} className="nav-link" to="/">
            Inicio
          </Link>
          <Link onClick={this.closeMenu} className="nav-link" to="/verificacion">
            Verificación de datos
          </Link>
          <Link onClick={this.closeMenu} className="nav-link" to="/notas">
            Notas
          </Link>
          <Link onClick={this.closeMenu} className="nav-link" to="/reportes">
            Reportes
          </Link>
          {/* <Link onClick={this.closeMenu} className="nav-link" to="/mapa">
            Mapa
          </Link> */}
        </nav>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.js